// src/SwapIcon.tsx
import { jsx } from "react/jsx-runtime";
var SwapIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.435 5.122c-.1.138-.33.362-.33.362-.812.867-2.833 2.172-3.859 2.592 0 .009-.61.257-.9.267h-.038a1.22 1.22 0 0 1-1.073-.648c-.088-.165-.17-.566-.209-.76a1 1 0 0 0-.023-.107c-.088-.572-.145-1.449-.145-2.411 0-1.01.057-1.926.164-2.488 0-.01.106-.524.175-.696.105-.247.3-.457.541-.59q.29-.143.609-.143c.222.009.638.152.802.218 1.084.42 3.154 1.792 3.947 2.63.088.088.18.187.245.256l.074.078c.165.21.252.467.252.744 0 .247-.078.495-.232.696M9.7 14.024a.784.784 0 0 1-.79-.778c0-.43.353-.779.79-.779l3.815-.214a1 1 0 0 1 1.007.992c0 .549-.45.992-1.007.992zm-2.562 2.41c-.107.247-.3.457-.541.59a1.36 1.36 0 0 1-.61.143c-.222-.01-.638-.152-.803-.22-1.083-.418-3.152-1.791-3.946-2.63-.086-.085-.177-.182-.241-.25v-.001l-.078-.082a1.2 1.2 0 0 1-.251-.743c0-.249.077-.496.232-.696.1-.139.329-.362.329-.362.812-.868 2.834-2.173 3.86-2.592 0-.01.608-.258.898-.268h.039c.445 0 .86.248 1.073.649.087.165.17.564.209.758.013.065.022.107.024.109.087.572.145 1.448.145 2.41 0 1.011-.058 1.926-.165 2.489 0 .009-.106.524-.174.695M7.425 4.42a.784.784 0 0 0-.79-.778l-3.816-.215a1 1 0 0 0-1.006.993c0 .548.45.992 1.006.992L6.635 5.2c.436 0 .79-.348.79-.778",
        fill: "currentColor"
      }
    )
  }
);
var SwapIcon_default = SwapIcon;

export {
  SwapIcon_default
};
